import React from 'react';
export default function StripCards(props) {
    var fields = props.fields, children = props.children;
    return (React.createElement("div", { className: "strip spa-strip-cards" },
        React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-12" },
                    React.createElement("h1", null, fields.title),
                    React.createElement("p", null, fields.content))),
            React.createElement("div", { className: "row" }, children && children.map(function (child) { return (React.createElement("div", { className: "col-md-4" },
                React.createElement("div", { className: "card-item" },
                    React.createElement("h5", { className: "card-title" }, child.fields.title),
                    React.createElement("p", { className: "card-text" }, child.fields.content)))); })))));
}
